import React from 'react'
import { Store } from './redux/Store'
import { Provider } from 'react-redux'
import { useRoutes } from 'react-router-dom'
import AppContext from './contexts/AppContext'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '../app/contexts/JWTAuthContext'
import { SettingsProvider } from '../app/contexts/SettingsContext'
import { DashboardProvider } from '../app/contexts/DashboardContext'
import useAuth from '../app/hooks/useAuth'
import { MatxTheme } from './components'
import { AllPages } from '../app/routes/routes';

const HomeRedirect = () => {
    const { user } = useAuth()
    return (
        <Navigate
            to={user?.role === 'SA' ? '/dashboard/analytics' : '/dashboard/default'}
        />
    )
}

const App = () => {
   
    const all_pages = useRoutes(AllPages());

    return (
        <AppContext.Provider>
            <Provider  store={Store}>
                <SettingsProvider>
                    <MatxTheme>
                        <AuthProvider>
                            <DashboardProvider>
                            {all_pages}
                                <Routes>
                                    <Route 
                                        path='/' 
                                        element={<HomeRedirect />}
                                />
                            </Routes>
                            </DashboardProvider>
                        </AuthProvider>
                    </MatxTheme>
                </SettingsProvider>
            </Provider>
        </AppContext.Provider >
    )
}

export default App
